import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import TabelaSubstituicoes from './tabelasubstituicoes';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { AnoReferenciaAbonoEspecial, convertToGMTPlus3, DataAmigavel, DataIso, PeriodosAquisitos, TempoAmigavelAteHoje, } from '@/shared/utils/datas';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { carregarAnoInicioFeriasSessenta, GetPeriodo, SetPeriodo, DeletePeriodo, GetDatasAquisitivasAbonoEspecial, GetDatasAquisitivasFerias, GetDatasAquisitivasLicencaPremio, } from '@/modules/business/periodo/periodo.service';
import {
  GetEventosInstitucionais,
  ReadEventoInstitucionalDto,
} from '@/modules/business/evento-institucional/evento-institucional.service';
import { maximoDiasFeriasDoPeriodo } from '@/modules/business/periodo/periodo-regras.utils';
import { IconeDoTipoPeriodo } from '@/modules/business/periodo/Icones';
import PeriodoRegrasCollapse from '@/modules/business/periodo/PeriodoRegrasCollapse';
import { useNavigate } from 'react-router-dom';
import { ReadDefensor } from '@/modules/people/defensor.service';
import { ReadSubstituicaoDto, UpdatePeriodoDto, ReadPeriodoDto, CreateSubstituicaoDto } from '@/api.types';
import { Tabelas } from '@/shared/constants/tables';
import { TipoPeriodoDescanso } from '../enums/tipo-periodo-descanso.enum';
import { getDataNascimentoDefensor } from '../periodo-folga-natalicia.utils';
import { TipoPeriodoDescansoList } from '@/shared/constants/enumlist';
import { toast } from 'react-toastify';
import { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';

export default function PeriodoEditPage() {
  const { setActions } = useBreadcrumbActions();
  const navigate = useNavigate();
  const params = useParams();

  const id = params.id ? Number(params.id) : 0;
  const [defensorid, setDefensorId] = useState(params.defensorid ? Number(params.defensorid) : 0);

  useEffect(() => {
    carregarAnoInicioFeriasSessenta()
      .then(setAnoInicioFeriasSessenta)
      .catch(() => setAnoInicioFeriasSessenta(null));
  }, []);

  useEffect(() => {
    const href = defensorid ? Links.Acoes_Criar + '/' + defensorid : Links.Acoes_Criar;
    setActions({
      secondary: { label: 'Novo', href, onClick: () => { } },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions, defensorid]);

  const [anoInicioFeriasSessenta, setAnoInicioFeriasSessenta] = useState<number | null>(null);
  const [aquisitivosFerias, setAquisitivosFerias] = useState<Date[]>([]);
  const [aquisitivosLicenca, setAquisitivosLicenca] = useState<Date[]>([]);
  const [aquisitivosAbono, setAquisitivosAbono] = useState<Date[]>([]);
  const [loaded, setLoaded] = useState(false);
  const [loaded2, setLoaded2] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [eventosInstitucionais, setEventosInstitucionais] = useState<ReadEventoInstitucionalDto[]>([]);
  const [eventoInstitucionalId, setEventoInstitucionalId] = useState<number>(0);

  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  const [formData, setFormData] = useState<Partial<ReadPeriodoDto>>({
    id: id,
    tipo: 0,
    defensor: {
      id: defensorid,
      ativo: false,
      data_admissao: ''
    } as any,
    exibiranotacao: true,
    ativorelatorio: true,
    rascunho: false,
  });

  useEffect(() => {
    GetEventosInstitucionais(0, 1000)
      .then((result) => {
        if (result?.objects) setEventosInstitucionais(result.objects);
      })
      .catch(() => setEventosInstitucionais([]));
  }, []);

  useEffect(() => {
    if (id > 0) {
      // Se for update.
      GetPeriodo(id)
        .then((result) => {
          if (result) {
            setFormData({
              ...formData,
              data_aquisitiva: result.data_aquisitiva,
              data_final: result.data_final,
              data_inicial: result.data_inicial,
              defensor: result.defensor,
              editadoEm: result.editadoEm,
              editadoPor: result.editadoPor,
              motivo: result.motivo,
              substituicoes: result.substituicoes,
              tipo: result.tipo,
              exibiranotacao: result.exibiranotacao,
              ativorelatorio: result.ativorelatorio,
              pontuar: result.pontuar,
              rascunho: result.rascunho,
            });

            setDefensorId(result.defensor!.id);
            const eventoId = result.eventoInstitucional?.id;
            setEventoInstitucionalId(eventoId && eventoId > 0 ? eventoId : 0);
            setLoaded(true);
          }
        })
        .catch((error) => console.error(error));
    } // Se for adição.
    else {
      ReadDefensor(defensorid)
        .then((result) => {
          setFormData({
            ...formData,
            defensor: result! as any
          });
          setLoaded(true);
        })
        .catch((error) => console.error(error));
    }
  }, []);

  useEffect(() => {
    if (loaded) {
      const dataUsar = (formData.defensor as any)?.data_referencia
        ? (formData.defensor as any)?.data_referencia
        : (formData.defensor as any)?.data_admissao;
      Promise.all([
        GetDatasAquisitivasFerias(dataUsar as unknown as Date)
          .then((datas) => {
            setAquisitivosFerias(datas);
          })
          .catch((error) => console.error(error)),

        GetDatasAquisitivasLicencaPremio(dataUsar as unknown as Date)
          .then((datas) => {
            setAquisitivosLicenca(datas);
          })
          .catch((error) => console.error(error)),

        GetDatasAquisitivasAbonoEspecial(dataUsar as unknown as Date)
          .then((datas) => {
            setAquisitivosAbono(datas);
          })
          .catch((error) => console.error(error)),
      ])
        .then(() => {
          setLoaded2(true);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
    }
  }, [loaded]);

  useEffect(() => {
    if (!loaded2 || formData.tipo !== TipoPeriodoDescanso.AbonoEspecial) return;
    if (aquisitivosAbono.length === 0) return;

    const anoAtual = formData.data_aquisitiva
      ? new Date(formData.data_aquisitiva).getFullYear()
      : null;
    const anoValido = aquisitivosAbono.some(
      (d) => new Date(d).getFullYear() === anoAtual,
    );
    if (anoValido) return;

    const padrao = referenciaAbonoPadrao(aquisitivosAbono);
    if (padrao) {
      setFormData((prev) => ({
        ...prev,
        data_aquisitiva: DataIso(padrao),
      }));
    }
  }, [loaded2, formData.tipo, aquisitivosAbono]);

  useEffect(() => {
    if (!loaded2 || formData.tipo !== TipoPeriodoDescanso.Ferias) return;
    if (aquisitivosFerias.length === 0) return;

    const isoAtual = formData.data_aquisitiva ? DataIso(formData.data_aquisitiva) : '';
    const valida =
      !!isoAtual && aquisitivosFerias.some((d) => DataIso(d) === isoAtual);
    if (valida) return;

    setFormData((prev) => ({
      ...prev,
      data_aquisitiva: DataIso(aquisitivosFerias[0]),
    }));
  }, [loaded2, formData.tipo, aquisitivosFerias]);

  useEffect(() => {
    if (!loaded2 || formData.tipo !== TipoPeriodoDescanso.LicencaPremio) return;
    if (aquisitivosLicenca.length === 0) return;

    const isoAtual = formData.data_aquisitiva ? DataIso(formData.data_aquisitiva) : '';
    const valida =
      !!isoAtual && aquisitivosLicenca.some((d) => DataIso(d) === isoAtual);
    if (valida) return;

    setFormData((prev) => ({
      ...prev,
      data_aquisitiva: DataIso(aquisitivosLicenca[0]),
    }));
  }, [loaded2, formData.tipo, aquisitivosLicenca]);

  function referenciaAbonoPadrao(datas: Date[]) {
    if (datas.length === 0) return undefined;
    const anoAtual = new Date().getFullYear();
    return (
      datas.find((d) => new Date(d).getFullYear() === anoAtual) ?? datas[0]
    );
  }

  function referenciaFolgaNatalicia() {
    const nascimento = getDataNascimentoDefensor(formData.defensor as any);
    return nascimento ? DataIso(nascimento) : undefined;
  }

  const handleSubstituicoes = useCallback((lista: ReadSubstituicaoDto[]) => {
    setFormData((prevFormData) => ({ ...prevFormData, substituicoes: lista }));
  }, []);

  const handleChange = (e: | React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {

    const target = e.target as HTMLInputElement | HTMLSelectElement;
    const name = target.name;
    const value = target.value;
    const checked = 'checked' in target ? (target as HTMLInputElement).checked : undefined;

    // Define que o início e fim são iguais para folgas natalícias.
    if ((name == 'data_inicial' || name == 'data_final') && formData.tipo == TipoPeriodoDescanso.FolgaNatalicia)
      setFormData({
        ...formData,
        data_inicial: value,
        data_final: value,
      });

    else if (name == 'tipo' && Number(value) == TipoPeriodoDescanso.FolgaNatalicia)
      setFormData({
        ...formData,
        tipo: Number(value) as 0 | 1 | 2 | 3 | 4 | 5 | 6,
        data_final: formData.data_inicial,
        data_aquisitiva: referenciaFolgaNatalicia() ?? formData.data_aquisitiva,
      });
    else if (name == 'tipo' && Number(value) == TipoPeriodoDescanso.Ferias) {
      const padrao = aquisitivosFerias[0];
      setFormData({
        ...formData,
        tipo: Number(value) as 0 | 1 | 2 | 3 | 4 | 5 | 6,
        data_aquisitiva: padrao ? DataIso(padrao) : formData.data_aquisitiva,
      });
    }
    else if (name == 'tipo' && Number(value) == TipoPeriodoDescanso.LicencaPremio) {
      const padrao = aquisitivosLicenca[0];
      setFormData({
        ...formData,
        tipo: Number(value) as 0 | 1 | 2 | 3 | 4 | 5 | 6,
        data_aquisitiva: padrao ? DataIso(padrao) : formData.data_aquisitiva,
      });
    }
    else if (name == 'tipo' && Number(value) == TipoPeriodoDescanso.AbonoEspecial) {
      const padrao = referenciaAbonoPadrao(aquisitivosAbono);
      setFormData({
        ...formData,
        tipo: Number(value) as 0 | 1 | 2 | 3 | 4 | 5 | 6,
        data_aquisitiva: padrao ? DataIso(padrao) : formData.data_aquisitiva,
      });
    }
    else if (name == 'tipo' && Number(value) == TipoPeriodoDescanso.Ferias) {
      const padrao = aquisitivosFerias[0];
      setFormData({
        ...formData,
        tipo: Number(value) as 0 | 1 | 2 | 3 | 4 | 5 | 6,
        data_aquisitiva: padrao ? DataIso(padrao) : formData.data_aquisitiva,
      });
    }
    else if (name == 'tipo' && Number(value) == TipoPeriodoDescanso.LicencaPremio) {
      const padrao = aquisitivosLicenca[0];
      setFormData({
        ...formData,
        tipo: Number(value) as 0 | 1 | 2 | 3 | 4 | 5 | 6,
        data_aquisitiva: padrao ? DataIso(padrao) : formData.data_aquisitiva,
      });
    }
    else if (name == 'exibiranotacao')
      setFormData({ ...formData, [name]: checked });
    else if (name == 'ativorelatorio')
      setFormData({ ...formData, [name]: checked });
    else if (name == 'pontuar') setFormData({ ...formData, [name]: checked });
    else if (name == 'rascunho') setFormData({ ...formData, [name]: checked });
    else setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    //setIsLoading(true);

    // Transformar substituições de ReadSubstituicaoDto para CreateSubstituicaoDto
    const substituicoesToSave: CreateSubstituicaoDto[] | undefined = formData.substituicoes
      ? formData.substituicoes.map((sub) => ({
        id: sub.id && sub.id > 0 ? sub.id : undefined,
        anotacao: sub.anotacao,
        pontuar: sub.pontuar,
        defensoria: sub.defensoria?.id ? { id: sub.defensoria.id } : undefined,
        substituto: sub.substituto?.id ? { id: sub.substituto.id } : undefined,
        periodo: id > 0 ? { id: id } : undefined,
      }))
      : undefined;

    const dataToSave: UpdatePeriodoDto = {
      id: formData.id,
      tipo: formData.tipo,

      data_inicial: formData.data_inicial ? convertToGMTPlus3(formData.data_inicial).toISOString() : undefined,

      data_final: formData.data_final ? convertToGMTPlus3(formData.data_final).toISOString() : undefined,

      data_aquisitiva:
        formData.tipo === TipoPeriodoDescanso.FolgaNatalicia
          ? referenciaFolgaNatalicia()
            ? convertToGMTPlus3(referenciaFolgaNatalicia()!).toISOString()
            : undefined
          : formData.data_aquisitiva
            ? convertToGMTPlus3(formData.data_aquisitiva).toISOString()
            : undefined,

      defensor: { id: formData.defensor!.id },
      motivo: formData.motivo,
      exibiranotacao: formData.exibiranotacao,
      ativorelatorio: formData.ativorelatorio,
      pontuar: formData.pontuar,
      rascunho: formData.rascunho,
      substituicoes: substituicoesToSave,
      eventoInstitucional: eventoInstitucionalId > 0 ? { id: eventoInstitucionalId } : undefined,
    };


    SetPeriodo(dataToSave)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Acoes_Index + '/' + defensorid}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      })
      .finally(() => setIsLoading(false));
  };

  const handleExcluir = (e: any) => {
    e.preventDefault();

    setModalExcluirShow(false);
    DeletePeriodo(id)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Acoes_Index + '/' + defensorid}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h4>Defensor(a): {(formData.defensor as any)?.nome || (formData.defensor as any)?.pessoa?.nome}</h4>
          <span className="blockquote-footer pb-4 text-end">
            Admissão: {DataAmigavel((formData.defensor as any)?.data_admissao)} (
            {TempoAmigavelAteHoje((formData.defensor as any)?.data_admissao as unknown as Date)}) /
            Idade: {DataAmigavel((formData.defensor as any)?.data_nascimento || (formData.defensor as any)?.pessoa?.dataNascimento)} (
            {TempoAmigavelAteHoje(((formData.defensor as any)?.data_nascimento || (formData.defensor as any)?.pessoa?.dataNascimento) as unknown as Date)}).
          </span>
        </div>
      </div>
      <hr className="pb-4" />

      <form onSubmit={handleSubmit}>
        <div className="row">

          {/* Tipo de Evento e data. */}
          <div className='col-md-4 mb-3'>
            <div className='card'>
              <div className='card-header text-center'>
                Ação / Evento
              </div>
              <div className='card-body'>
                <label htmlFor="tipo" className="form-label">
                  {IconeDoTipoPeriodo(Number(formData.tipo) as TipoPeriodoDescanso)} Tipo de Evento:
                </label>
                <select title="Tipo" className="form-select mb-3" name="tipo" id="tipo" onChange={handleChange} value={formData.tipo}>
                  {TipoPeriodoDescansoList.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.name}
                    </option>
                  ))}
                </select>

                <label htmlFor="eventoInstitucional" className="form-label">
                  Evento institucional
                </label>
                <select
                  id="eventoInstitucional"
                  className="form-select"
                  value={eventoInstitucionalId || ''}
                  onChange={(e) => setEventoInstitucionalId(Number(e.target.value) || 0)}
                >
                  <option value="">(nenhum)</option>
                  {eventosInstitucionais.map((evento) => (
                    <option key={evento.id} value={evento.id}>
                      {evento.titulo}
                    </option>
                  ))}
                </select>
              </div>
              <PeriodoRegrasCollapse
                tipo={Number(formData.tipo) as TipoPeriodoDescanso}
                tetoDiasFerias={maximoDiasFeriasDoPeriodo(
                  formData.data_aquisitiva
                    ? new Date(formData.data_aquisitiva).getFullYear()
                    : Number.NaN,
                  anoInicioFeriasSessenta,
                )}
              />
            </div>
          </div>

          {/* Período de Vigência */}
          <div className='col-md-4'>
            <div className='card'>
              <div className='card-header text-center'>
                Referência e Vigência
              </div>
              <div className='card-body row'>
                <div className='mb-3'>
                  {formData.tipo == TipoPeriodoDescanso.Ferias && (
                    <div>
                      <label htmlFor="data_aquisitiva_select" className="form-label">
                        Período Aquisitivo Férias:
                      </label>
                      <select
                        title="Referência"
                        className="form-select"
                        id="data_aquisitiva_select"
                        name="data_aquisitiva"
                        value={DataIso(formData.data_aquisitiva) || ''}
                        onChange={handleChange}
                        required
                      >
                        {aquisitivosFerias.map((item, index) => (
                          <option key={index} value={DataIso(item)}>
                            {PeriodosAquisitos(item)}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {formData.tipo == TipoPeriodoDescanso.LicencaPremio && (
                    <div>
                      <label htmlFor="data_aquisitiva" className="form-label">
                        Período Aquisitivo Licença:
                      </label>
                      <select title="Referência" className="form-select" id="data_aquisitiva_select" name="data_aquisitiva" value={DataIso(formData.data_aquisitiva) || ''} onChange={handleChange} >
                        {aquisitivosLicenca.map((item, index) => (
                          <option key={index} value={DataIso(item)}>
                            {DataAmigavel(item)}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {formData.tipo == TipoPeriodoDescanso.AbonoEspecial && (
                    <div>
                      <label htmlFor="data_aquisitiva_select" className="form-label">
                        Ano de Referência:
                      </label>
                      <select
                        title="Ano de referência"
                        className="form-select"
                        id="data_aquisitiva_select"
                        name="data_aquisitiva"
                        value={DataIso(formData.data_aquisitiva) || ''}
                        onChange={handleChange}
                        required
                      >
                        {aquisitivosAbono.map((item, index) => (
                          <option key={index} value={DataIso(item)}>
                            {AnoReferenciaAbonoEspecial(item)}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {formData.tipo == TipoPeriodoDescanso.FolgaNatalicia && (
                    <div>
                      <label htmlFor="data_aquisitiva" className="form-label">
                        Data de Nascimento (Referência):
                      </label>
                      <input
                        id="data_aquisitiva"
                        title="Data de nascimento"
                        type="date"
                        className="form-control"
                        name="data_aquisitiva"
                        value={referenciaFolgaNatalicia() || ''}
                        readOnly
                      />
                    </div>
                  )}

                  {formData.tipo != TipoPeriodoDescanso.Ferias &&
                    formData.tipo != TipoPeriodoDescanso.LicencaPremio &&
                    formData.tipo != TipoPeriodoDescanso.AbonoEspecial &&
                    formData.tipo != TipoPeriodoDescanso.FolgaNatalicia && (
                      <div>
                        <label htmlFor="data_aquisitiva" className="form-label">
                          Referência:
                        </label>
                        <input id="data_aquisitiva" title="Data Aquisição" type="date" className="form-control" name="data_aquisitiva" value={DataIso(formData.data_aquisitiva) || ''} onChange={handleChange} />
                      </div>
                    )}
                </div>

                <div className="col-md-6">
                  <label htmlFor="data_inicial" className="form-label">
                    Data Inicial:
                  </label>
                  <input
                    id="data_inicial"
                    title="Data Inicial"
                    type="date"
                    className="form-control"
                    name="data_inicial"
                    value={DataIso(formData.data_inicial) || ''}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className='col-md-6'>
                  <label htmlFor="data_final" className="form-label">
                    Data Final:
                  </label>
                  <input
                    id="data_final"
                    title="Data Final"
                    type="date"
                    className="form-control"
                    name="data_final"
                    value={DataIso(formData.data_final) || ''}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Parâmetros */}
          <div className='col-md-4 mb-4'>
            <div className='card'>
              <div className='card-header text-center'>
                Parâmetros
              </div>
              <div className='card-body'>
                <div className="form-check" title="Exibir no relatório.">
                  <input className="form-check-input" type="checkbox" name="exibiranotacao" id="exibiranotacao" onChange={handleChange} checked={formData.exibiranotacao || false} />
                  <label className="form-check-label" htmlFor="exibiranotacao">Anotação no Relatório</label>
                </div>

                <div className="form-check" title="Se ativo exibe no relatório e gera notificação."   >
                  <input className="form-check-input" type="checkbox" name="ativorelatorio" id="ativorelatorio" onChange={handleChange} checked={formData.ativorelatorio || false} />
                  <label className="form-check-label" htmlFor="ativorelatorio">Ativo no Relatório</label>
                </div>

                <div className="form-check" title="Se gera pontuação">
                  <input className="form-check-input" type="checkbox" name="pontuar" id="pontuar" onChange={handleChange} checked={formData.pontuar || false} />
                  <label className="form-check-label" htmlFor="pontuar">Pontuar</label>
                </div>

                <div className="form-check" title="Se é rascunho, não será considerado em relatórios">
                  <input className="form-check-input" type="checkbox" name="rascunho" id="rascunho" onChange={handleChange} checked={formData.rascunho || false} />
                  <label className="form-check-label" htmlFor="rascunho">Rascunho</label>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 mb-4">
            <div className="card">
              <div className="card-header text-center">
                Anotações
              </div>
              <div className="card-body">
                <input
                  id="motivo"
                  title="Anotações"
                  type="text"
                  className="form-control"
                  name="motivo"
                  value={formData.motivo || ''}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {loaded &&
            <div>
              <TabelaSubstituicoes updateSubstituicoes={handleSubstituicoes} defensorid={defensorid} />
            </div>
          }
          <br />

          <EditadoPorRodape dados={{ editadoPor: (formData as ReadPeriodoDto)?.editadoPor, editadoEm: (formData as ReadPeriodoDto)?.editadoEm }} />

          <BotoesSalvarExcluir isLoading={isLoading} texto={btnSalvar} textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'} id={id} onExcluirClick={() => setModalExcluirShow(true)} />
        </div>
      </form>

      <ModalExcluir show={modaExcluirShow} handleExcluir={handleExcluir} handleHide={() => setModalExcluirShow(false)}></ModalExcluir>
      <ModalHistorico show={modalHistorico} handleHide={() => setModalHistorico(false)} tabela={Tabelas.periodo} idRegistro={id} ></ModalHistorico>
    </>
  );
}
